import {
  useEffect, useState, useCallback, useContext,
} from 'react';
import useIntersectionObserverWithRef from './useIntersectionObserverWithRef';
import BreakpointContext from '../../contexts/BreakpointContext';

export default function useScrollBehavior(buyGridRef, inlineButtonRef) {
  const [isStickyVisible, setIsStickyVisible] = useState(true);
  const [isFullBleedVisible, setIsFullBleedVisible] = useState(false);

  const breakpoints = useContext(BreakpointContext);
  const navBarHeight = useCallback(() => (breakpoints.large ? 75 : 55), [breakpoints.large]);
  const isVisible = useIntersectionObserverWithRef({ rootMargin: `-${navBarHeight()}px 0px 0px 0px` }, inlineButtonRef);

  useEffect(() => {
    const handleScroll = () => {
      const buyGridContainer = buyGridRef.current?.getBoundingClientRect();
      const marginBelowBuyGrid = 60;

      if (!buyGridContainer) return;
      setIsFullBleedVisible(buyGridContainer.bottom < marginBelowBuyGrid);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [buyGridRef]);

  useEffect(() => {
    if (typeof isVisible === 'boolean') {
      setIsStickyVisible(!isVisible);
    }
  }, [isVisible]);

  return { isStickyVisible, isFullBleedVisible };
}
